


























































import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';

@Component({
  components: {
    CollapseTransition,
  },
})
export default class SetSecretQuestion extends Vue {
  showSetSecretQuestionFlag = false;

  value1: any = '';
  value2: any = '';
  value3: any = '';
  questions: any[] = [
    {
      id: '1',
      value: '问题1',
      label: '您目前的姓名是？',
    },
    {
      id: '2',
      value: '问题2',
      label: '您配偶的生日是？',
    },
    {
      id: '3',
      value: '问题3',
      label: '您的学号(或工号)是？',
    },
    {
      id: '4',
      value: '问题4',
      label: '您的生日是？',
    },
    {
      id: '5',
      value: '问题5',
      label: '您母亲的生日是？',
    },
    {
      id: '6',
      value: '问题6',
      label: '您母亲的姓名是？',
    },
    {
      id: '7',
      value: '问题7',
      label: '您父亲的生日是？',
    },
    {
      id: '8',
      value: '问题8',
      label: '您父亲的姓名是？',
    },
    {
      id: '9',
      value: '问题9',
      label: '您配偶的姓名是？',
    },
    {
      id: '10',
      value: '问题10',
      label: '您初中班主任的名字是？',
    },
  ];

  secretQuestionForm: object = {
    firstAnswer: '',
    secondAnswer: '',
    thirdAnswer: '',
  };

  secretQuestionRules: object = {
    firstAnswer: [{ required: true, message: '请选择密保问题', trigger: 'blur' }],
    secondAnswer: [{ required: true, message: '请选择密保问题', trigger: 'change' }],
    thirdAnswer: [{ required: true, message: '请选择密保问题', trigger: 'change' }],
  };

  backPersonalCenter(): void {
    this.$emit('close');
  }

  private submitSecretQuestion(formName: any): void {
    const secretQuestionForm: any = 'secretQuestionForm';
    const secretSelect: any = this.$refs[secretQuestionForm];
    secretSelect.validate((valid: any) => {
      if (valid) {
        this.$message.success('保存成功！');
        this.$emit('close');
        console.log(123);
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
}
